import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { label } from "../../lib/format";
import { Card, Field, PageHeader } from "../../components/common/UI";
import { Button } from "../../components/ui/button";

const FIELDS = ["name", "region", "province", "city_municipality", "barangay", "address", "email", "contact_number", "website", "legislative_body_name", "secretary_office", "lce_office", "timezone"];

export default function LguSettings() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/lgu").then((r) => setF(r.data)); }, []);
  if (!f) return null;
  const save = async () => {
    const body = Object.fromEntries(FIELDS.map((k) => [k, f[k] || null]));
    body.timezone = f.timezone || "Asia/Manila";
    body.public_portal_enabled = !!f.public_portal_enabled;
    body.retention_config = f.retention_config;
    try { setF(await api.put("/lgu", body).then((r) => r.data)); toast.success("LGU profile saved"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="fade-up">
      <PageHeader eyebrow="Administration" title="LGU Settings" subtitle={`${f.code} · ${label(f.lgu_type)} · changes are recorded in the audit log`}
        actions={<Button className="bg-sky-600 hover:bg-sky-700" onClick={save} data-testid="lgu-save-button">Save</Button>} />
      <Card title="Profile" testId="lgu-profile">
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
          {FIELDS.map((k) => (
            <Field key={k} label={label(k)}><input className="otms-input" value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`lgu-field-${k}`} /></Field>
          ))}
          <label className="flex items-center gap-2 pt-6 text-xs"><input type="checkbox" checked={!!f.public_portal_enabled} onChange={(e) => setF({ ...f, public_portal_enabled: e.target.checked })} data-testid="lgu-public-portal" />Public portal enabled (portal ships in Phase 5)</label>
        </div>
      </Card>
    </div>
  );
}
